import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { css } from "@emotion/react";
import { useParams } from "react-router";
import { PageWrapper, Grid } from "components/Containers";
import { Spinner } from "components/Loader";
import { margins } from "style";
import Card from "components/Card";
import PageTitle from "components/PageTitle";
import { GeneralSettingsForm } from "components/Squads/settings";
import { useTeam } from "hooks";

/**
 * GeneralSettings
 */
const GeneralSettings = () => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { loading: teamLoading, data } = useTeam({ id });

  useEffect(() => {
    setLoading(teamLoading);
  }, [teamLoading]);

  if (loading) {
    return <Spinner margin={margins.normal} size={`1.5rem`} />;
  }

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Squads.GeneralSettings.Title" })}</title>
      </Helmet>
      <PageWrapper>
        <Grid>
          <Grid.col start={1} end={13}>
            <PageTitle subtitle={<FormattedMessage id="Squads.Settings.GeneralSettings.Title" />} />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <Card css={styles.card}>
              <GeneralSettingsForm data={data} />
            </Card>
          </Grid.col>
        </Grid>
      </PageWrapper>
    </>
  );
};

const styles = {
  card: css`
    padding: 0;
  `,
};

export default GeneralSettings;
